import { render, staticRenderFns } from "./CategoryScroll.vue?vue&type=template&id=f345f556&scoped=true&"
import script from "./CategoryScroll.vue?vue&type=script&lang=js&"
export * from "./CategoryScroll.vue?vue&type=script&lang=js&"
import style0 from "./CategoryScroll.vue?vue&type=style&index=0&id=f345f556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f345f556",
  null
  
)

export default component.exports